import { render } from "./welcome.vue?vue&type=template&id=3b5b46eb&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=3b5b46eb&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5b46eb"]])

export default __exports__